import axiosInstance from './axiosInstance';
import { getUserInfoDetails } from '../utlis';

// Helper to get current user context
const getUserContext = () => {
  const { companyId, clientId } = getUserInfoDetails();
  return { companyId, clientId };
};

// Validate that an ID is a positive integer before using in URL paths
const validateId = (id, name = 'ID') => {
  const parsed = parseInt(id, 10);
  if (isNaN(parsed) || parsed <= 0) throw new Error(`Invalid ${name}`);
  return parsed;
};

// Update vendor (PUT)
export const updateVendor = (reqBody, vendorId) => {
  const safeId = validateId(vendorId, 'vendor ID');
  const { companyId, clientId } = getUserContext();
  return axiosInstance.put(`/vendors/${safeId}?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`, reqBody);
};

// POST Request

export const createJobLead = async (data) => {
  const { companyId, clientId } = getUserContext();
  return axiosInstance.post(`/jobs?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`, {
    jobTitle: data.jobTitle,
    vendorId: +data.vendorId,
    vendorContactId: +data.vendor_contact_id,
    salesPersonId: +data.sales_person_id,
    technologyId: +data.technology,
    endClientName: data.client,
    payType: data.payType,
    billRate: +data.billRate,
    noOfOpenings: +data.numOfPositions,
    duration: +data.durationMonths,
    jobDesc: data.jobDescription,
    city: data.city,
    state: data.state,
    statusReason: data.statusReason,
    status: data.status || 'OPEN',
  });
};

export const updateJobLead = async (data) => {
  const safeJobId = validateId(data.jobId, 'job ID');
  const { companyId, clientId } = getUserContext();
  return axiosInstance.put(`/jobs/${safeJobId}?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`, {
    jobTitle: data.jobTitle,
    vendorId: +data.vendorId,
    vendorContactId: +data.vendor_contact_id,
    salesPersonId: +data.sales_person_id,
    technologyId: +data.technology,
    endClientName: data.client,
    payType: data.payType,
    billRate: +data.billRate,
    noOfOpenings: +data.numOfPositions,
    duration: +data.durationMonths,
    jobDesc: data.jobDescription,
    city: data.city,
    state: data.state,
    statusReason: data.statusReason,
    status: data.status,
  });
};

export const assignJobToCandidate = async (jobData, candidateId, masterJobId, candidateSalesPersonId) => {
  const safeCandidateId = validateId(candidateId, 'candidate ID');
  const { companyId, clientId } = getUserContext();
  const res = await axiosInstance.post(`/jobs?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}&candidateId=${safeCandidateId}`, {
    candidateId: +candidateId,
    recordType: 'CANDIDATE',
    masterJobId: +masterJobId,
    jobTitle: jobData.job_title,
    vendorId: jobData.vendor_id ? +jobData.vendor_id : 0,
    vendorContactId: jobData.vendor_contact_id ? +jobData.vendor_contact_id : 0,
    salesPersonId: candidateSalesPersonId ? +candidateSalesPersonId : 0,
    technologyId: jobData.technology_id ? +jobData.technology_id : 0,
    endClientName: jobData.client || '',
    payType: jobData.pay_type || '',
    billRate: jobData.bill_rate ? +jobData.bill_rate : 0,
    noOfOpenings: jobData.no_of_openings ? +jobData.no_of_openings : 0,
    duration: jobData.duration ? parseInt(jobData.duration) || 0 : 0,
    jobDesc: jobData.job_desc || '',
    city: jobData.city || '',
    state: jobData.state || '',
    statusReason: jobData.status_reason || '',
    status: 'Assigned',
  });
  if (res.data?.statusCode && res.data.statusCode >= 300) {
    throw new Error(res.data.details || res.data.message || 'Failed to assign job');
  }
  return res;
};

export const createSalesInterview = (data) => {
  const { companyId, clientId } = getUserContext();
  const payload = {
    division: 'division',
    candidateId: +data.candidateName,
    vendorId: +data.vendor,
    jobId: +data.job,
    client: data.clientName,
    company: data.clientCompany,
    technology_id: +data.technology,
    schedulingStatus: data.interviewStatus,
    interviewDate: data.interviewDate,
    interviewTime: data.interviewTime,
    appointmentLink: data.link,
    interviewPanelDetails: `${data.interviewer1},${data.interviewer2}`,
    feedback: data.feedback,
    rating: data.rating ? data.rating.toString() : "0",
    ...(data.masterJobId && { masterJobId: +data.masterJobId }),
    ...(data.marketingId && { marketingId: +data.marketingId }),
  };
  return axiosInstance.post(`/interview?company=${encodeURIComponent(companyId)}&client=${encodeURIComponent(clientId)}`, payload);
};

export const createProject = (data) => {
  const { companyId, clientId } = getUserContext();
  return axiosInstance.post(`/projects?company=${encodeURIComponent(companyId)}&client=${encodeURIComponent(clientId)}`, data);
};

export const UpdateProject = (data) => {
  const safeProjectId = validateId(data.project_id, 'project ID');
  const { companyId, clientId } = getUserContext();
  return axiosInstance.post(
    `/projects/${safeProjectId}?company=${encodeURIComponent(companyId)}&client=${encodeURIComponent(clientId)}`,
    data,
  );
};

export const updateSalesInterview = (data) => {
  const { companyId, clientId } = getUserContext();
  const payload = {
    division: 'division',
    candidateId: +data.candidateName,
    vendorId: +data.vendor,
    jobId: +data.job,
    client: data.clientName,
    company: data.clientCompany,
    technology_id: +data.technology,
    schedulingStatus: data.interviewStatus,
    interviewDate: data.interviewDate,
    interviewTime: data.interviewTime,
    appointmentLink: data.link,
    interviewPanelDetails: `${data.interviewer1},${data.interviewer2}`,
    feedback: data.feedback,
    rating: data.rating ? data.rating.toString() : "0",
    ...(data.masterJobId && { masterJobId: +data.masterJobId }),
    ...(data.marketingId && { marketingId: +data.marketingId }),
  };

  const safeInterviewId = validateId(data.interviewId, 'interview ID');
  return axiosInstance.put(
    `/interview/${safeInterviewId}?company=${encodeURIComponent(companyId)}&client=${encodeURIComponent(clientId)}`,
    payload,
  );
};

export const createSalesTeam = async (data) => {
  const { companyId, clientId } = getUserContext();
  return axiosInstance.post(`/salesteam?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`, data);
};

export const updateSalesTeam = async (salesPersonId, data) => {
  const safeId = validateId(salesPersonId, 'sales person ID');
  const { companyId, clientId } = getUserContext();
  return axiosInstance.put(
    `/salesteam/${safeId}?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`,
    data,
  );
};

export const createSalesContact = async (data) => {
  const { companyId, clientId } = getUserContext();
  return axiosInstance.post(`/contacts?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`, data);
};

export const updateSalesContact = async (data) => {
  const safeId = validateId(data.contact_id, 'contact ID');
  const { companyId, clientId } = getUserContext();
  return axiosInstance.put(
    `/contacts/${safeId}?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`,
    data,
  );
};

export const createContactNote = async (data) => {
  const { companyId, clientId } = getUserContext();
  return axiosInstance.post(`/notes?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`, {
    notes: data,
    recordType: 'contact',
  });
};

export const getAllSalesContacts = () => {
  const { companyId, clientId } = getUserContext();
  return axiosInstance.get(`/contacts?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`);
};

export const getAllSalesVendors = () => {
  const { companyId, clientId } = getUserContext();
  return axiosInstance.get(`/vendors?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`);
};

export const searchContacts = (searchText, pageNum = 1, pageSize = 100) => {
  const { companyId, clientId } = getUserContext();
  return axiosInstance.post(
    `/contacts/searches?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}&pageNum=${pageNum}&pageSize=${pageSize}`,
    { searchText }
  );
};

export const searchJobs = (searchText, pageNum = 1, pageSize = 100) => {
  const { companyId, clientId } = getUserContext();
  return axiosInstance.post(
    `/jobs/searches?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}&pageNum=${pageNum}&pageSize=${pageSize}`,
    { searchText }
  );
};

export const searchVendors = (searchText, pageNum = 1, pageSize = 100) => {
  const { companyId, clientId } = getUserContext();
  return axiosInstance.post(
    `/vendors/search?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}&pageNum=${pageNum}&pageSize=${pageSize}`,
    { searchText }
  );
};

export const createVendor = (reqBody) => {
  const { companyId, clientId } = getUserContext();
  return axiosInstance.post(`/vendors?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`, reqBody);
};

export const getVendorDetailsById = (id) => {
  const safeId = validateId(id, 'vendor ID');
  const { companyId, clientId } = getUserContext();
  return axiosInstance.get(`/vendors/${safeId}?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`);
};

export const getAllTechnologies = () => {
  const { companyId, clientId } = getUserContext();
  return axiosInstance.get(`/technology?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`);
};

export const createTechnology = (data) => {
  const { companyId, clientId } = getUserContext();
  return axiosInstance.post(`/technology?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`, {
    technologyName: data.technologyName,
    description: data.description,
    terminology: {
      test: data.terminology,
    },
  });
};

export const updateTechnology = (data) => {
  const safeId = validateId(data.technologyId, 'technology ID');
  const { companyId, clientId } = getUserContext();
  return axiosInstance.put(
    `/technology/${safeId}?client=${encodeURIComponent(clientId)}&company=${encodeURIComponent(companyId)}`,
    {
      technologyName: data.technologyName,
      description: data.description,
      terminology: {
        test: data.terminology,
      },
    },
  );
};
